export default __webpack_public_path__ + "static/media/deal.white.623ee47e.svg";